export const jewelryoptions = [
	  { value: 'Bone', label: 'Bone', parm: 'jewelry' },
	  { value: 'Crystal', label: 'Crystal', parm: 'jewelry' },
	  { value: 'Eagle', label: 'Eagle', parm: 'jewelry' },
	  { value: 'Key', label: 'Key', parm: 'jewelry' },
	  { value: 'Pizza', label: 'Pizza', parm: 'jewelry' },
	  { value: 'Red Gem', label: 'Red Gem', parm: 'jewelry' },
	  { value: 'Skull Necklace', label: 'Skull Necklace', parm: 'jewelry' },
	  { value: 'Teddy Bear', label: 'Teddy Bear', parm: 'jewelry' },
];